import { FC } from 'react';
import { Box, useTheme } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { observer } from 'mobx-react-lite';

import { AssessmentStatus } from '@libs/constants';
import { CheckCircleIcon, ClockIcon, NotebookIcon, PaperPlaneTiltIcon, XCircleIcon } from '@phosphor-icons/react';

interface AssessmentStatusIconProps {
  status: AssessmentStatus;
  sx?: SxProps<Theme>;
}

export const AssessmentStatusIcon: FC<AssessmentStatusIconProps> = observer(({ status, sx }) => {
  const theme = useTheme();

  const StatusIcon = observer(({ status }: Pick<AssessmentStatusIconProps, 'status'>) => {
    switch (status) {
      case AssessmentStatus.DRAFT:
        return <NotebookIcon size={20} color={theme.palette.text.secondary} />;
      case AssessmentStatus.SUBMITTED:
        return <PaperPlaneTiltIcon size={20} color={theme.palette.text.secondary} />;
      case AssessmentStatus.PROCESSING:
        return <ClockIcon size={20} color={theme.palette.text.secondary} />;
      case AssessmentStatus.COMPLETED:
        return <CheckCircleIcon size={20} color={theme.palette.text.secondary} />;
      case AssessmentStatus.FAILED:
        return <XCircleIcon size={20} color={theme.palette.text.secondary} />;
      default:
        return <NotebookIcon size={20} color={theme.palette.text.secondary} />;
    }
  });

  return <Box sx={sx}>{<StatusIcon status={status} />}</Box>;
});
